export default __webpack_public_path__ + "images/e451151f6ca39a7f6d66de16bd2d4fe2.gif";